import React from "react";
import componentStyle from '@/styles/Component.scss';
import globalStyle from '@/styles/Global.scss'
import _ from "lodash";
import {Form} from "react-bootstrap";
import {addTemporaryFile} from "@/api/file";
import {TemporaryFile} from "@/entity/TemporaryFile";
import {Photo} from "@/entity/Photo";
import {displayTypes} from "@/components/homePage/HomePageComponents";

const HomePageEditor = ({
  photo = new Photo({}),
  updatePhoto = (photo) => {},
  onFileUpload = ( temporaryFile ) => {}
}) => {
  const readFile = (e) => {
    e.preventDefault()
    if (!e.target.files.length) {
      return
    }
    let file = e.target.files[0]
    let fr = new FileReader()
    fr.onload = async (event) => {
      const temporaryFile = await addTemporaryFile({ temporaryFile: new TemporaryFile({  mime: file.type, contents: event.target.result }) })
      onFileUpload(temporaryFile)
    }
    fr.readAsDataURL(file)
  }

  return (
    <>
      <div className={componentStyle.inputArea}>
        <div className={globalStyle.attribute}>
          <Form>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>見出し</Form.Label>
              <Form.Control type="text" value={photo.title} onChange={(e) => updatePhoto(new Photo({...photo, title: e.target.value }))} placeholder="見出しを入力してください。" />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>本文</Form.Label>
              <Form.Control as="textarea" value={photo.comment} onChange={(e) => updatePhoto(new Photo({...photo, comment: e.target.value }))} placeholder="本文を入力してください。" />
            </Form.Group>
            <Form.Group controlId="formFile" className="mb-3">
              <Form.Label>写真を選択します。</Form.Label>
              <Form.Control onInput={readFile} type="file"/>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>並び順</Form.Label>
              <Form.Control type="text" value={photo.sort} onChange={(e) => updatePhoto(new Photo({...photo, sort: e.target.value }))} placeholder="並び順を入力してください。" />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>表示順</Form.Label>
              <Form.Select aria-label="表示順" value={photo.displayType} onChange={(e) => updatePhoto(new Photo({...photo, displayType: e.target.value}))}>
                {
                  _.map(displayTypes, (type) => {
                    return (
                      <React.Fragment key={type.type}>
                        <option value={type.type}>{type.display}</option>
                      </React.Fragment>
                    )
                  })
                }
              </Form.Select>
            </Form.Group>
          </Form>
        </div>
      </div>
    </>
  )
}
export default HomePageEditor
